import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, inject, Renderer2, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { OffClickDirective } from '@df/module-off-click/off-click.directive';
import { ToggleService } from '@df/ui/toggle/toggle.service';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { IconButtonComponent } from '../../../common/buttons/icon-button/icon-button.component';
import { AbstractPageSearchFormComponent } from '../../search/form/abstract-page-search-form.component';
import { NPageSearch } from '../../search/page-search.interfaces';
import { NPageHeader } from '../page-header.component';

@Component({
    imports: [CommonModule, IconButtonComponent, OffClickDirective, TranslatePipe, FormsModule],
    selector: 'page-header-search-form',
    templateUrl: './page-header-search-form.html',
    styleUrl: './page-header-search-form.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageHeaderSearchFormComponent extends AbstractPageSearchFormComponent {
    /**
     * Icon when form is visible
     */
    @ViewChild('iconOn', { read: ElementRef })
    private iconOnRef?: ElementRef<HTMLElement>;

    /**
     * Icon when form is not visible
     */
    @ViewChild('iconOff', { read: ElementRef })
    private iconOffRef?: ElementRef<HTMLElement>;

    /**
     * If form is visible
     */
    override isVisible = false;

    /**
     * Currently set animation shift
     */
    private animationShift = 0;

    private readonly renderer2 = inject(Renderer2);
    private readonly elementRef = inject(ElementRef);
    private readonly toggleService = inject(ToggleService);
    /**
     * Toggle full component visibility
     */
    toggleVisibility(to: boolean): void {
        if (this.isVisible !== to) {
            this.isVisible = to;
            if (to) {
                this.renderer2.addClass(this.elementRef.nativeElement, '_open');
                this.toggleService.open([NPageHeader.MEGANAV_GROUP_ID, NPageSearch.SEARCH_MEGANAV_KEY]);
                this.detectChanges();
            } else {
                this.renderer2.removeClass(this.elementRef.nativeElement, '_open');
                this.reset();
                this.toggleService.close([NPageHeader.MEGANAV_GROUP_ID, NPageSearch.SEARCH_MEGANAV_KEY]);
            }
        }
    }
}
